import L from 'leaflet';
import ImageReposition from "./ImageReposition";
import 'leaflet.heat';
import BaseComponent from "../../BaseComponent";

export default class ImageRatingView extends BaseComponent
{
    private $img: JQuery<HTMLElement>;
    private $filter: JQuery<HTMLElement>;
    private $imageContainer: JQuery;
    private readonly disposePopups = new Set<() => void>();
    private disposed = false;
    private filterRequest = 0;

	public init(): void {

        this.$img = $('[data-image]', this.$component);
        this.$filter = $('[data-filter]', this.$component);
        this.$imageContainer = this.$component.find('[data-image-container]');

        (new ImageReposition()).initialize(this.context.naja);

        const self = this;

        this.$img.imgRating({
            icon: {
                borderColor: '#23426f',
                backgroundColor: '#337ab7',
                textColor: '#23426f'
            },
            beforeIconCreated: function(iconOptions, data) {
                if (data.rating > 0) {
                    iconOptions.borderColor = '#3c763d';
                    iconOptions.backgroundColor = '#69AA46';
                    iconOptions.textColor = '#3c763d';
                } else if (data.rating < 0) {
                    iconOptions.borderColor = '#a94442';
                    iconOptions.backgroundColor = '#d74543';
                    iconOptions.textColor = '#a94442';
                }
            },
            onMarkerAdded: function(marker, data) {
                // @ts-ignore
                const rrosePopup = new L.Rrose({
                    offset: new L.Point(0,-10),
                    closeButton: false,
                    autoPan: false
                });
                self.bindTranslatedPopup(marker, rrosePopup, data);

                marker.bindPopup(rrosePopup);

                const widget = this;
                marker.on('popupopen', () => {
                    widget.markers?.forEach(m => {
                        if (m !== marker) {
                            m.setOpacity(0.5);
                        }
                    });
                });
                marker.on('popupclose', () => {
                    widget.markers?.forEach(m => m.setOpacity(1));
                });
            },
            afterInit: function() {
                this.import(self.options.ratings);

                const hash = window.location.hash;
                const match = hash.match(/^#rating-(\d+)$/);
                if (match) {
                    const targetRatingId = parseInt(match[1], 10);
                    const marker = this.markers?.find(m => m.ratingId === targetRatingId);
                    if (marker) {
                        marker.openPopup();
                        self.$component[0]?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                }
            },
            onImport: function(data) {
                const heatmapData = [];

                if (Array.isArray(data)) {
                    for (let item of data) {
                        const loc = this.relposToLatLng(item.x, item.y);
                        heatmapData.push([loc.lat, loc.lng, item.rating]);
                    }
                }
                // @ts-ignore
                L.heatLayer(heatmapData, {minOpacity: 0.80, blur: 30, radius: 30}).addTo(this.map);
            },
            viewDestination: this.$imageContainer[0],
        });

        const $opacitySlider = this.$component.find('[data-opacity-slider]');
        $opacitySlider.on('input', () => {
            const opacity = parseFloat($opacitySlider.val() as string);
            const instance = this.$img.imgRating('instance') as unknown as {zimg?: L.ImageOverlay};
            if (instance && instance.zimg) {
                instance.zimg.setOpacity(opacity);
            }
        });

        const $selectAllUsersCheckbox = this.$filter.find('[data-select-all-users]');
        $selectAllUsersCheckbox.on('click', function() {
			const $users = $('[name="users[]"]', self.$filter);

			if ($(this).is(':checked')) {
				$users.prop('checked', true);
			} else {
				$users.prop('checked', false);
			}
		});

        const $selectUserCheckboxes = this.$filter.find('[data-select-user-checkbox]');
        $selectUserCheckboxes.on('change', ()=> {
             if ($selectUserCheckboxes.toArray().every(ch => $(ch).is(':checked'))) {
                 $selectAllUsersCheckbox.prop('checked', true);
             } else {
                 $selectAllUsersCheckbox.prop('checked', false);
             }
        });

		$('form', this.$filter).on('submit', (e) => {
            e.preventDefault();

            const $form = <JQuery<HTMLFormElement>>$(e.currentTarget);

            const request = ++this.filterRequest;
            this.context.naja.uiHandler.submitForm($form[0]).then(payload => {
                if (this.disposed || !this.$component[0].isConnected || request !== this.filterRequest) {
                    return;
                }
                this.$img.imgRating('clear');
                this.$img.imgRating('import', payload.ratings);
            });

        });

        $('[name="rating"], [name="users[]"], [data-select-all-users]', this.$filter).on('change', function() {
            $(this).closest('form').trigger('submit');
            self.updateAnalyzeLink();
        });

        this.updateAnalyzeLink();
        this.initAnalyzePrompt();
	}

    private bindTranslatedPopup(marker: L.Marker, popup: L.Popup, data): void {
        let content: HTMLElement | null = null;
        let showOriginal = false;
        let removed = false;
        const updateGeometry = (): void => {
            if (popup.isOpen()) {
                popup.update();
            }
        };
        const rememberMode = (event: MouseEvent): void => {
            const button = (event.target as HTMLElement).closest('button');
            if (button?.hasAttribute('data-translation-show-original')) {
                showOriginal = true;
            } else if (button?.hasAttribute('data-translation-show-translated')) {
                showOriginal = false;
            }
        };
        const close = (): void => {
            if (!content) {
                return;
            }
            content.removeEventListener('content-translation-state-changed', updateGeometry);
            content.removeEventListener('click', rememberMode);
            this.context.components?.unmount($(content).find('[data-content-translation]'));
            content = null;
        };
        const open = (): void => {
            if (removed || this.disposed) {
                return;
            }
            close();
            content = document.createElement('div');
            if (typeof data.popupHtml === 'string') {
                content.innerHTML = data.popupHtml;
            } else {
                const heading = document.createElement('h4');
                heading.textContent = data.userName;
                content.appendChild(heading);
                String(data.note ?? '').split(/\r\n|\r|\n/).forEach((line, index) => {
                    if (index > 0) {
                        content.appendChild(document.createElement('br'));
                    }
                    content.appendChild(document.createTextNode(line));
                });
            }
            popup.setContent(content);
            content.addEventListener('content-translation-state-changed', updateGeometry);
            content.addEventListener('click', rememberMode);
            this.context.components?.mount($(content).find('[data-content-translation]'));
            if (showOriginal) {
                content.querySelectorAll<HTMLButtonElement>('[data-translation-show-original]')
                    .forEach(button => button.click());
            }
            updateGeometry();
        };
        const remove = (): void => {
            removed = true;
            close();
            marker.off('popupopen', open);
            marker.off('popupclose', close);
            marker.off('remove', remove);
            this.disposePopups.delete(remove);
        };
        // Leaflet needs content before it can open a popup; fill it after insertion.
        popup.setContent(document.createElement('div'));
        marker.on('popupopen', open);
        marker.on('popupclose', close);
        marker.on('remove', remove);
        this.disposePopups.add(remove);
    }

    public beforeRemove(): void {
        this.disposed = true;
        this.disposePopups.forEach(dispose => dispose());
        this.$img?.imgRating('clear');
    }

    private initAnalyzePrompt(): void {
        const $link = this.$component.find('[data-analyze-heatmap-link]');
        if ($link.length === 0) {
            return;
        }

        const $modal = this.$component.find('[data-analyze-heatmap-modal]');
        const $submitBtn = $modal.find('[data-analyze-prompt-submit]');
        const $textarea = $modal.find('[data-analyze-prompt-input]');

        $submitBtn.on('click', () => {
            const href = $link.attr('href') ?? '';
            const url = new URL(href, window.location.origin);

            const customPrompt = ($textarea.val() as string ?? '').trim();
            if (customPrompt !== '') {
                url.searchParams.set('customPrompt', customPrompt);
            }

            window.location.href = url.toString();
        });

        // Clear textarea when modal is closed
        $modal.on('hidden.bs.modal', () => {
            $textarea.val('');
        });
    }

    private updateAnalyzeLink(): void {
        const $link = this.$component.find('[data-analyze-heatmap-link]');
        if ($link.length === 0) {
            return;
        }

        // Store original href on first call to avoid drift from repeated mutations
        if (!$link.data('base-href')) {
            $link.data('base-href', $link.attr('href'));
        }

        const originalHref = $link.data('base-href') as string;
        const baseUrl = originalHref.split('?')[0] ?? '';
        const params = new URLSearchParams(originalHref.split('?')[1] ?? '');

        // Collect selected user IDs from checkboxes
        const selectedUserIds: string[] = [];
        this.$filter.find('[data-select-user-checkbox]:checked').each(function () {
            const val = $(this).val();
            if (val) {
                selectedUserIds.push(String(val));
            }
        });

        // Check if all users are selected (= no filter needed)
        const allUserCheckboxes = this.$filter.find('[data-select-user-checkbox]');
        const allSelected = allUserCheckboxes.length === selectedUserIds.length;

        if (!allSelected && selectedUserIds.length > 0) {
            params.set('respondentIds', selectedUserIds.join(','));
        } else {
            params.delete('respondentIds');
        }

        // Collect selected rating type from radio buttons
        const selectedRating = this.$filter.find('[name="rating"]:checked').val();
        if (selectedRating && selectedRating !== 'all') {
            params.set('ratingType', String(selectedRating));
        } else {
            params.delete('ratingType');
        }

        $link.attr('href', baseUrl + '?' + params.toString());
    }
}
